import React from 'react';
import { InvoicePdfContent } from './InvoicePdfContent.jsx';

/** Separater Angebots-Renderer, damit Angebot und Rechnung unabhängig erweitert werden können. */
export function QuotePdfContent(props) {
  return <InvoicePdfContent {...props} type="quote" />;
}
